import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone } from "lucide-react";
import logo from "@/assets/masonry-pro-logo-3.webp";
import { NavLink } from "./NavLink";

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Services", href: "/services" },
    { name: "Financing", href: "/financing" },
    { name: "About", href: "/about" },
    { name: "Gallery", href: "/gallery" },
    { name: "Pro Tips", href: "/pro-tips" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border/50">
      {/* Top bar */}
      <div className="bg-primary py-2 px-4">
        <div className="container mx-auto flex justify-center md:justify-between items-center text-sm">
          <p className="hidden md:block text-primary-foreground/80">
            35+ Years Experience
          </p>
          <a 
            href="tel:+19737252395" 
            className="flex items-center gap-2 text-secondary font-semibold hover:text-secondary/80 transition-colors"
          >
            <Phone className="h-4 w-4" />
            Get a Free Quote: (973) 725-2395
          </a>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img 
              src={logo} 
              alt="Masonry Pro Construction" 
              className="h-14 md:h-16 w-auto"
              width={160}
              height={64}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <NavLink key={link.name} href={link.href}>
                {link.name}
              </NavLink>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link to="/contact">
              <Button variant="gold" size="lg">
                Free Assessment
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2 text-foreground"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-background border-b border-border animate-fade-in">
            <div className="container mx-auto px-4 py-4 flex flex-col gap-2">
              {navLinks.map((link) => (
                <NavLink 
                  key={link.name} 
                  href={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="py-2"
                >
                  {link.name}
                </NavLink>
              ))}
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
                <Button variant="gold" className="mt-2 w-full">
                  Free Assessment
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
